import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import Preloader from 'components/Preloader';
import { useReportFilterInfo, useGetLeadReport } from 'hooks/query/useReport';
import { changePeriod } from '../reportUtils';
import LeadJobList from './LeadJobList';
import Filter from './Filter';
import { moveSizesToOptions, reportDataToCompaniesOptions, createMoveSizeRecord } from './utils';

const Lead = () => {
  const { data: filterData } = useReportFilterInfo();

  const moveSizes = filterData?.move_sizes;
  const companies = filterData?.companies;
  const allCompanies = filterData?.all_companies;

  const { mutate: getLeadReport, data: leadReportResponse, isLoading } = useGetLeadReport();

  const report = leadReportResponse?.data;

  const moveSizesOptions = React.useMemo(() => moveSizesToOptions(moveSizes), [moveSizes]);
  const companiesOptions = React.useMemo(() => reportDataToCompaniesOptions(companies, allCompanies), [companies, allCompanies]);
  const moveSizesRecord = React.useMemo(() => createMoveSizeRecord(moveSizes), [moveSizes]);

  const { values, setFieldValue, handleSubmit, errors, touched } = useFormik({
    initialValues: {
      company_id: companiesOptions[0]?.value ?? 0,
      move_size_id: null,
      status: null,
      from: null,
      to: null,
      period_type: 0,
    },
    onSubmit: (values) => getLeadReport(values),
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      status: Yup.number().nullable().required('Select Status'),
    }),
  });

  if (!filterData) return null;

  const isValidHandler = (name) => {
    if (errors[name] && touched[name]) return errors[name];
    return null;
  };

  const selectDate = ({ name, date }) => setFieldValue(name, moment(date).format('MM/DD/YY'));

  const handleSelect = (name, value) => setFieldValue(name, value);

  const selectPeriod = ({ value }) => {
    const { from, to } = changePeriod(value);
    setFieldValue('from', from);
    setFieldValue('to', to);
    setFieldValue('period_type', value);
  };

  const formActions = { isValidHandler, handleSelect, selectPeriod, selectDate, handleSubmit };

  return (
    <React.Fragment>
      {isLoading && <Preloader />}

      <Filter values={values} data={{ companiesOptions, moveSizesOptions }} actions={formActions} />
      {report && <LeadJobList list={report} moveSizesRecord={moveSizesRecord} />}
    </React.Fragment>
  );
};

export default Lead;
